const education = {
  hero: {
    title: 'Центр підготовки операторів БпЛА Pegasus Arms 25',
    description:
      'Місце, де готують тих, хто змінює хід війни. Ми створюємо команду операторів безпілотних систем нового покоління. Наші випускники — це не просто пілоти, а бойові фахівці, здатні ефективно діяти у найскладніших умовах.',
  },
  offer: {
    title: 'Що ми пропонуємо',
    paragraphs: [
      '3 тижні інтенсивного курсу під керівництвом інструкторів із реальним бойовим досвідом.',
      'Програма поєднує теорію, практику та підготовку в умовах, максимально наближених до бойових.',
    ],
    items: [
      '36 академічних годин теорії та практики',
      '36 годин льотної підготовки',
      'Керування ударними БпАК «PEGASUS ARMS 25» із різними типами бойового комплекту',
      'Виконання бойових завдань та робота в складних погодних умовах',
      'Протидія ворожим дронам та застосування РЕБ/РЕР, антидронових засобів',
      'Комплексний іспит (теорія + екзаменаційний політ)',
      'Сертифікат, що надає дозвіл на бойове застосування Pegasus Arms 25.',
    ],
  },
}
export default education
